import { PropsWithChildren, useMemo } from 'react'

type Props = {
  className?: string
}

const PageWrapper = ({ children, className }: PropsWithChildren<Props>) => {
  const classes = useMemo(() => {
    let str = 'max-w-[1000px] mx-auto px-4 '
    if (className) str += className
    return str
  }, [className])
  return <div className={classes}>{children}</div>
}

export default PageWrapper
